import Venue from "../../../../src/components/Home/Venue";
import NextVenImg28 from "../../../../src/images/venue-28/28-01.jpg";
import * as React from 'react';
export default {
  Venue,
  NextVenImg28,
  React
};